/**
 * Mobile bottom bar + WhatsApp FAB behavior.
 * Externalized from sections/mobile-bottom-bar-whatsapp.liquid.
 *
 * - [data-autoactive]: highlights the item matching the current page.
 * - Sliding pill behind the active item, kept in sync by ResizeObserver.
 * - Tap feedback: icon bounce + the pill glides to the tapped link.
 * - [data-autohide]: hides while scrolling down, reveals on scroll up.
 */
function initMbb(root) {
  if (!root || root.dataset.mbbInit) return;
  root.dataset.mbbInit = '1';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const bar = root.querySelector('.ix-mbb__bar');
  if (!bar) return;

  /* highlight the item matching the current page */
  if (root.hasAttribute('data-autoactive')) {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    let match = null;
    bar.querySelectorAll('a.ix-mbb__item[href^="/"]').forEach((link) => {
      const linkPath = (link.pathname || '').replace(/\/+$/, '') || '/';
      if (linkPath === path) match = link;
      else if (!match && linkPath !== '/' && path.indexOf(linkPath + '/') === 0) match = link;
    });
    if (match) {
      bar.querySelectorAll('.ix-mbb__item--active').forEach((el) => {
        el.classList.remove('ix-mbb__item--active');
      });
      match.classList.add('ix-mbb__item--active');
    }
  }

  /* sliding pill behind the active item */
  const pill = document.createElement('span');
  pill.className = 'ix-mbb__pill';
  pill.setAttribute('aria-hidden', 'true');
  // appended, not prepended: the bar places items with :nth-child rules
  bar.append(pill);
  const placePill = (target, animate) => {
    const active = target || bar.querySelector('.ix-mbb__item--active');
    if (!active) {
      pill.classList.remove('is-on');
      return;
    }
    if (!animate) pill.style.transition = 'none';
    pill.style.width = `${active.offsetWidth}px`;
    pill.style.transform = `translateX(${active.offsetLeft}px)`;
    if (!animate) {
      void pill.offsetWidth;
      pill.style.transition = '';
    }
    pill.classList.add('is-on');
  };
  placePill(null, false);
  if ('ResizeObserver' in window) {
    new ResizeObserver(() => {
      placePill(null, false);
    }).observe(bar);
  }

  /* tap feedback: icon bounce + pill glides to tapped link */
  bar.addEventListener('pointerdown', (event) => {
    const item = event.target.closest('.ix-mbb__item');
    if (!item || reduceMotion) return;
    item.classList.remove('is-tap');
    void item.offsetWidth;
    item.classList.add('is-tap');
    const href = item.getAttribute('href');
    if (href && href.charAt(0) === '/') placePill(item, true);
  });

  /* hide while scrolling down, reveal on scroll up */
  if (root.hasAttribute('data-autohide') && !reduceMotion) {
    let lastY = window.scrollY;
    let pending = false;
    window.addEventListener(
      'scroll',
      () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          const y = window.scrollY;
          const delta = y - lastY;
          if (Math.abs(delta) < 6) return;
          root.classList.toggle('is-hidden', delta > 0 && y > 140);
          lastY = y;
        });
      },
      { passive: true }
    );
  }
}

document.querySelectorAll('.ix-mbb').forEach(initMbb);

/* theme editor: init sections re-rendered after a settings change */
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.ix-mbb').forEach(initMbb);
});
